export default __webpack_public_path__ + "b54179c9018e816d673c12558c08e7c9.svg";